import { render } from "./SelecaoStatus.vue?vue&type=template&id=25501b59&scoped=true"
import script from "./SelecaoStatus.vue?vue&type=script&lang=js"
export * from "./SelecaoStatus.vue?vue&type=script&lang=js"

import "./SelecaoStatus.vue?vue&type=style&index=0&id=25501b59&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25501b59"]])

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSelect});
